"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchParamValueFromUrl = void 0;
const getSearchParamValueFromUrl = (urlStr, paramName) => {
    if (urlStr.includes('?')) {
        const queryParams = urlStr.split('?')[1];
        if (queryParams) {
            return new URLSearchParams(queryParams).get(paramName);
        }
    }
    return null;
};
exports.getSearchParamValueFromUrl = getSearchParamValueFromUrl;
